import React from 'react'
import { LaunchTag } from '../../components/LaunchTag'
import { AnchoredAlert } from '../../components/AnchoredAlert'
import { FeatureIntroductionAlert } from '../../components/FeatureIntroductionAlert'
import { Element } from '.'
import { ExpandedPageBanner } from '../../components/ExpandedPageBanner'
import { LaunchModal } from '../../components/LaunchModal'

// defines how backend metadata maps to frontend component
// backend "type" -> frontend react component
// props accept:
// 1. string -> string
// 2. string -> function: json
export default {
  TAG: {
    component: LaunchTag,
    props: {
      tagType: 'type',
    },
  },
  POPOVER: {
    component: AnchoredAlert,
    props: {
      inlineLink: 'inlineLink',
      action: 'action',
      imageInstance: 'image',
      triggerWidgetId: (id): Record<string, unknown> => ({ trigger: <Element id={id} /> }),
    },
  },
  FEATURE_INTRODUCTION_ALERT: {
    component: FeatureIntroductionAlert,
  },
  EXPANDED_PAGE_BANNER: {
    component: ExpandedPageBanner,
  },
  LAUNCH_MODAL: {
    component: LaunchModal,
  },
}
